(function () {
  function parseItems(raw) {
    try {
      return JSON.parse(raw || '[]');
    } catch (e) {
      return [];
    }
  }

  function fetchConfigFallback(type) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/' + (type || 'json'),
      },
    };
  }

  function showWarning(message) {
    if (window.MinimogTheme && window.MinimogTheme.Notification) {
      window.MinimogTheme.Notification.show({
        target: document.body,
        method: 'append',
        type: 'warning',
        message: message,
        delay: 400,
      });
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-rhh-start-here-bundle]');
    if (!button || button.disabled) return;

    event.preventDefault();

    const items = parseItems(button.getAttribute('data-items'));
    if (!items.length) {
      showWarning('Unable to load sample bundle. Please refresh and try again.');
      return;
    }

    const fetchConfigFn = typeof fetchConfig === 'function' ? fetchConfig : fetchConfigFallback;

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = fetchConfigFn('javascript');
    config.method = 'POST';
    config.body = JSON.stringify({
      items: items,
      sections: sectionsToBundle,
      sections_url: window.location.pathname,
    });

    button.classList.add('m-spinner-loading');
    button.disabled = true;

    const { MinimogSettings, MinimogStrings } = window;
    const cartAddUrl =
      MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart_add_url
        ? MinimogSettings.routes.cart_add_url
        : '/cart/add.js';
    const cartDrawer = document.querySelector('m-cart-drawer');

    fetch(cartAddUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Unable to add sample bundle.');
        }

        if (MinimogSettings && MinimogSettings.use_ajax_atc) {
          if (cartDrawer && MinimogSettings.enable_cart_drawer) {
            if (window.MinimogTheme && window.MinimogTheme.Notification) {
              window.MinimogTheme.Notification.show({
                target: cartDrawer.querySelector('m-cart-items'),
                method: 'prepend',
                type: 'success',
                message: MinimogStrings && MinimogStrings.itemAdded,
                delay: 400,
              });
            }
            cartDrawer.open();
          } else if (window.MinimogTheme && window.MinimogTheme.Notification) {
            window.MinimogTheme.Notification.show({
              target: document.body,
              method: 'append',
              type: 'success',
              message: MinimogStrings && MinimogStrings.itemAdded,
              delay: 400,
            });
          } else if (MinimogSettings.routes && MinimogSettings.routes.cart) {
            window.location = MinimogSettings.routes.cart;
            return;
          }
        } else if (MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.cart) {
          window.location = MinimogSettings.routes.cart;
          return;
        }

        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
        }

        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            bubbles: true,
            detail: { product: response },
          })
        );
      })
      .catch(function (error) {
        showWarning(error.message || 'Unable to add sample bundle.');
      })
      .finally(function () {
        button.classList.remove('m-spinner-loading');
        button.disabled = false;
      });
  });
})();
